import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch } from 'react-redux';
import { useSearchParams, useLocation } from 'react-router-dom'
import intl from 'react-intl-universal'

import { useActivate } from 'react-activation'

import Cookies from 'js-cookie'

import { Skeleton, Toast, Image } from 'antd-mobile'


import { setTheme } from '../../store/reducers/theme';
import { setIconSet } from '../../store/reducers/hotel';
import { setOwnLanguages } from '../../store/reducers/language';
import { setChainInfo as setChainInfoRedux } from '../../store/reducers/chain';

import { formatJSON } from '../../utils'
import { refreshLatLngToStorage } from '../../utils/geolocation'
import { getLanguageStore } from '../../utils/storage/language'
import { addBehaviorsRecord } from '../../utils/BehaviorstatsHelp'
import SelectLanguage from '../../components/SelectLanguage'
import PromotionList from '../../components/PromotionList'
import NavigationBar from '../../components/NavigationBar'
import LanugagePage from '../../components/LanugagePage';
import MediaBox from '../../components/MediaBox';
import MaxKBChatBot from '../../components/MaxKBChatBot';

import { setMemberInfo, getMemberInfo, setThemeStore, setOwnStores, setChainInfo, setOnlyDisplayStore } from '../../utils/storage/store'
import { setScopeParam, getPageScopeLanguage, setTimeoutNum, setCodeExtendColumn, setShuttleBusInfo, getFromView, setFromView, setHeadStoreInfoSession } from '../../utils/session/store'
import { getRelateStoreInfoModel, registerModel, getIconByStoreIdModel } from '../../model/store';
// import { bannerList } from '../../data/products'
// import CategoryGrid from './GategoryGrid'
import IconGrid from './IconGrid'
import RelateStoreCard from './RelateStoreCard'
import { initWatchTimeout } from '../../utils/timeoutHandle';


import FoodIcon from '../../assets/images/icon/icon_food.png'
import ServiceIcon from '../../assets/images/icon/icon-hkeeping.png'
import SPAIcon from '../../assets/images/icon/icon-spa.png'
import TourIcon from '../../assets/images/icon/icon-tour.png'
import CarIcon from '../../assets/images/icon/icon-car.png'
import ActivityIcon from '../../assets/images/icon/icon-act.png'
import BagIcon from '../../assets/images/icon/icon-sale.png'
import FeedbacIcon from '../../assets/images/icon/icon-feedback.png'
import FacilityIcon from '../../assets/images/icon/icon-fac.png'
import VIPIcon from '../../assets/images/icon/vips.png'

/*
import FoodIcon from '../../components/Icon/FoodIcon'
import ServiceIcon from '../../components/Icon/ServiceIcon'
import SPAIcon from '../../components/Icon/SPAIcon'
import TourIcon from '../../components/Icon/TourIcon'
import CarIcon from '../../components/Icon/CarIcon'
import ActivityIcon from '../../components/Icon/ActivityIcon'
import BagIcon from '../../components/Icon/BagIcon'
import FeedbacIcon from '../../components/Icon/FeedbackIcon';
import FacilityIcon from '../../components/Icon/FacilityIcon';

import ProductCard from './ProductCard'
import MerchantCard from './MerchantCard'
import RecomProductCard from './RecomProductCard'
import RestaurantCard from './RestaurantCard'
import SpaCard from './SpaCard'
//*/
import './index.less'


// 首先定义常量配置
const STORE_TYPES = {
  FOOD: [1],  // 点餐、餐厅、pool bar
  HOUSEKEEPING: 2,  // 客房服务
  SPA: 3,          // SPA
  ACTIVITIES: 10,   // 活动
  TOURS: 11,       // 旅游
  CARS: 8,         // 穿梭巴士
  AMENITILES: 99,  // 设施
  FEEDBACK: 100,   // 评价
  PRIVILEGE: 101,   // 住客特权
  SOUVENIR: 14,   // 纪念品
};

const CATEGORY_CONFIG = [
  {
    id: 1,
    name: 'Food & Beverage',
    icon: <img src={FoodIcon} alt='Food & Beverage' className='ct-img' />,
    type: 1,
    sort: 1,
    storeTypes: STORE_TYPES.FOOD
  },
  {
    id: 2,
    name: 'House Keeping',
    icon: <img src={ServiceIcon} alt='House Keeping' className='ct-img' style={{ width: 32 }} />,
    type: 2,
    sort: 2,
    storeTypes: [STORE_TYPES.HOUSEKEEPING]
  },
  {
    id: 3,
    name: 'Amenitiles',
    icon: <img src={FacilityIcon} alt='Amenitiles' className='ct-img' style={{ width: 28 }} />,
    type: 99,
    sort: 3,
    storeTypes: [STORE_TYPES.AMENITILES]
  },
  {
    id: 4,
    name: 'Limousine Service',
    icon: <img src={CarIcon} alt='Limousine Service' className='ct-img' />,
    type: 8,
    sort: 4,
    storeTypes: [STORE_TYPES.CARS]
  },
  {
    id: 5,
    name: 'SPA',
    icon: <img src={SPAIcon} alt='SPA' className='ct-img' />,
    type: 3,
    sort: 5,
    storeTypes: [STORE_TYPES.SPA]
  },
  {
    id: 6,
    name: 'Activities',
    icon: <img src={ActivityIcon} alt='Activities' className='ct-img' style={{ width: 32 }} />,
    type: 10,
    sort: 6,
    storeTypes: [STORE_TYPES.ACTIVITIES]
  },
  {
    id: 7,
    name: 'Tour',
    icon: <img src={TourIcon} alt='Tour' className='ct-img' style={{ width: 26 }} />,
    type: 11,
    sort: 7,
    storeTypes: [STORE_TYPES.TOURS]
  },
  {
    id: 8,
    name: 'Survey & Feedback',
    icon: <img src={FeedbacIcon} alt='Survey & Feedback' className='ct-img' />,
    type: 100,
    sort: 8,
    storeTypes: [STORE_TYPES.FEEDBACK]
  },
  {
    id: 9,
    name: 'Souvenir',
    icon: <img src={BagIcon} alt='Souvenir' className='ct-img' style={{ width: 36 }} />,
    type: 14,
    sort: 9,
    storeTypes: [STORE_TYPES.SOUVENIR]
  },
  {
    id: 10,
    name: 'Privilege',
    icon: <img src={VIPIcon} alt='Privilege' className='ct-img' style={{ width: 36 }} />,
    type: 101,
  }
];



const Home = () => {
  const [state, setState] = useState({
    storeInfo: {},
    loading: false,
    languages: [],
    categories: [],
    bannerList: [],
    activityList: [],
    activityDetail: {},
    detailShow: false
  });

  const [searchParams] = useSearchParams();

  const allParams = Object.fromEntries(searchParams.entries());
  const { areaid } = allParams;

  const dispatch = useDispatch();
  // const currentTheme = useSelector(selectTheme);
  // let fromNav = location && location.state && location.state.action === 'nav'

  // 保存滚动位置
  const saveScrollPosition = useCallback(() => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    sessionStorage.setItem('homeScrollPosition', scrollTop.toString());
  }, []);

  // 恢复滚动位置
  const restoreScrollPosition = useCallback(() => {
    const savedScrollPosition = sessionStorage.getItem('homeScrollPosition');
    if (savedScrollPosition) {
      window.scrollTo(0, parseInt(savedScrollPosition));
    }
  }, []);

  useActivate(() => {
    // 当页面被激活（从其他页面返回）时执行
    const fromView = getFromView()
    console.log(fromView, 'fromView')
    if (fromView) {
      setFromView(null)
    }

    // 刷新主题
    dispatch(setTheme(state.storeInfo.color));
    console.log(state.storeInfo.color, 'state.storeInfo.color')
  });

  // 监听路由变化
  useEffect(() => {
    const handleRouteChange = () => {
      saveScrollPosition();
    };

    window.addEventListener('beforeunload', handleRouteChange);
    return () => {
      window.removeEventListener('beforeunload', handleRouteChange);
    };
  }, [saveScrollPosition]);

  // 组件挂载时恢复滚动位置
  useEffect(() => {
    restoreScrollPosition();
  }, [restoreScrollPosition]);

  // useEffect(() => {
  //   refreshLatLngToStorage();
  // }, []);

  const handleApiError = (error) => {
    console.error('API Error:', error);
    Toast.show({
      icon: 'fail',
      content: error.message || '操作失败'
    });
  };

  const loadStoreInfo = async () => {

    try {
      setState(prev => ({ ...prev, loading: true }));
      const res = await getRelateStoreInfoModel({
        curLanguage: getLanguageStore(),
        areaId: areaid,
        memberId: getMemberInfo()?.memberId,
        lat: '',
        lng: ''
      });

      const { languages, color, partnerId, images, partnerName, stores, facilities, area, extendColumn, areaType } = res;
      const categories = getCategorys(res);
      let banners = []
      if (images && images.length > 0) {
        banners = images.split(',').map(item => ({ acivityId: 0, type: 'image', url: item }))
      }

      setState(prev => ({
        ...prev,
        storeInfo: res,
        loading: false,
        languages,
        categories,
        bannerList: banners
      }));

      setScopeParam({
        areaId: areaid,
        partnerId,
        name: partnerName,
        area,
        href: window.location.href,
        areaType,
        chainExtendColumn: extendColumn,
        roomTypeId: res.roomTypeId,
        chainStoreId: res.storeId
      })
      setCodeExtendColumn(formatJSON(extendColumn))
      setOwnStores(stores)
      setOnlyDisplayStore(res.isForDisplayOnly)
      dispatch(setOwnLanguages(languages));
      dispatch(setTheme(color));
      setHeadStoreInfoSession(res)
      setChainInfo(res) // 保存到 localStorage
      dispatch(setChainInfoRedux(res)) // 保存到 Redux
      await initMember(partnerId);
      // await getActivityList({ banners: images, partnerId });
      // await getRelateIconList(partnerId);
      setTimeoutNum(res.scanTimeOut || 0)
      initWatchTimeout()

      //班车信息
      const busObj = res.privilege?.find(item => item.showType === 4)
      setShuttleBusInfo(busObj)


      //记录首次访问首面的行为统计
      addBehaviorsRecord({
        behaviorType: 160200,
        behavior: 160201,
        storeId: res.storeId,
      })
    } catch (error) {
      handleApiError(error);
      setState(prev => ({ ...prev, loading: false }));
    }
  };

  const initMember = async (outPartnerId) => {
    try {
      const uuidKey = Cookies.get('GUEST_UUID_KEY') || '';
      const { memberId = '' } = getMemberInfo() || {};

      if (!memberId || (memberId && uuidKey.length > 0 && uuidKey !== memberId)) {
        const param = {
          language: getLanguageStore(),
          registerFromSubId: areaid,
          registerFrom: 2,
          registerFromId: outPartnerId,
          clientAgent: window.navigator.userAgent,
          registerLanguage: window.navigator.language
        };
        const data = await registerModel(param);
        setMemberInfo(data);
      }
    } catch (error) {
      handleApiError(error);
    }
  };
  const getCategorys = (res) => {
    const { stores, facilities } = res;

    // 处理设施类别
    const amenitiles = {
      type: 99,
      name: 'Amenitiles',
      icon: <img src={FacilityIcon} alt='Amenitiles' style={{ width: 32 }} />,
      sort: 3,
      partnerId: ''
      // childList: facilities
      //   .map(item => ({
      //     id: item.serviceId,
      //     sort: item.sort,
      //     name: item.title,
      //     icon: <Image src={item.image} />,
      //     item
      //   }))
      //   .sort((a, b) => a.sort - b.sort)
    };

    const feedback = {
      id: 8,
      name: 'Survey & Feedback',
      icon: <img src={FeedbacIcon} alt='Survey & Feedback' style={{ width: 28 }} />,
      type: 100,
      storeTypes: [STORE_TYPES.FEEDBACK],
      sort: 9999
    }
    const vip = {
      id: 10,
      name: 'Privilege',
      icon: <img src={VIPIcon} alt='Privilege' style={{ width: 36 }} />,
      type: 101,
      sort: 9999
    }

    // const souvenir = {
    //   id: 9,
    //   name: 'Souvenir',
    //   icon: <BagIcon width={40} height={40} />,
    //   type: 101,
    //   sort: 9999
    // }

    // 通用处理子项的函数
    const renderChild = (list) => list
      .map(item => ({
        id: item.storeId,
        sort: item.sort,
        type: item.type,
        name: item.shortName || item.name,
        icon: <Image src={item.logo || item.image} />,
        item
      }))
      .sort((a, b) => a.sort - b.sort);

    // 生成分类数组
    const categories = CATEGORY_CONFIG
      .reduce((acc, category) => {
        const filteredStores = stores.filter(store =>
          Array.isArray(category.storeTypes)
            ? category.storeTypes.includes(store.type)
            : store.type === category.storeTypes
        );

        if (filteredStores.length > 0) {
          const childList = renderChild(filteredStores)
          acc.push({
            ...category,
            icon: category.icon,
            sort: category.id,
            relates: childList[0],
            childList
          });
        }

        return acc;
      }, [amenitiles, feedback, vip]);

    return categories.sort((a, b) => a.sort - b.sort);
  }


  const getRelateIconList = (storeId) => {
    getIconByStoreIdModel({ storeId }).then(res => {
      const storeIcon = {},
        categoryIcon = {},
        arrIcons = []

      res.forEach(item => {
        switch (item.relateType) {
          case 1: //storeIcon
            storeIcon[item.relateId] = item
            break
          case 2: //categoryIcon
            categoryIcon[item.relateId] = item
            break
          case 3:
            const ids = item.relateName.split(',').map(id => parseInt(id))

            const arr = res.filter(data => ids.includes(data.id))
            if (arr.length > 0) {
              item.childList = arr
              arrIcons.push(item)
            }

            break
          default:
            break
        }
      })
      dispatch(setIconSet({ storeIcon, categoryIcon, arrIcons }))
      console.log(res)
    }).catch(err => {
      console.log(err)
    })
  }

  const handleHomeRefresh = () => {
    loadStoreInfo();
  }

  useEffect(() => {
    loadStoreInfo();
  }, [areaid]);

  const { storeInfo: { partnerName, stores = [], extendColumn, extendColumn1 }, loading, languages, categories } = state;
  const extendData = formatJSON(extendColumn) || {}
  const extendData1 = formatJSON(extendColumn1) || {}

  // const aaa = intl.get('order_detail').d('detail...')
  // console.log(aaa, 'mutillllllan======')

  // const restaurantArr = stores.filter(item => [7, 9].includes(item.type))
  // const diningArr = stores.filter(item => item.type === 1 && item.products.length > 0)
  // const spaArr = stores.filter(item => item.type === 3)
  // const actStore = stores.find(item => item.type === 10)
  // const tourStore = stores.find(item => item.type === 11)
  // const souvenirStore = stores.find(item => item.type === 14)


  const pageLanguage = getPageScopeLanguage()
  console.log(pageLanguage, 'pageLanguage')
  if (!pageLanguage && state.storeInfo && state.storeInfo.partnerId) {
    return <LanugagePage storeInfo={state.storeInfo} />
  }

  return (
    <div className='home-wrapper'>
      <div className='top-box hide'>
        <header className='header' style={{ background: 'transparent' }}>
          <div className='pos_rel'>
            <div className='title ellips'>{partnerName} </div>
            {Object.keys(state.storeInfo).length > 0 ? <div className='lan-box'><SelectLanguage lanItem={languages} storeInfo={state.storeInfo} /></div> : null}
          </div>
        </header>

      </div>
      <div className='main-box'>
        {
          loading ? (
            <div>
              <Skeleton.Title active={loading} />
              <Skeleton.Paragraph lineCount={5} animated active={loading} />
            </div>
          ) : (
            <>
              <div className='banner-box'>
                {/* <Banner banners={state.bannerList} />
                <TopAlbum albumId={7} /> */}
                <MediaBox
                  storeInfo={state.storeInfo}
                  bannerProps={{ banners: state.bannerList, from: 'chain', getActFromRes: false }}
                />
              </div>
              <div className='jm-flex h-mc-info p10'>
                <div className='h-mc-name jm-flex-item'>{partnerName}</div>
                <div className='h-mc-lan-box'>
                  {
                    Object.keys(state.storeInfo).length > 0
                      ?
                      <div className='lan-box'>
                        <SelectLanguage lanItem={languages} storeInfo={state.storeInfo} />
                      </div>
                      : null
                  }
                </div>
              </div>

              {/* 测试按钮：调试信息 */}
              {process.env.NODE_ENV === 'development' && (
                <div style={{ padding: '10px 15px', textAlign: 'center' }}>
                  <button
                    onClick={() => {
                      console.log('调试信息按钮被点击');
                      console.log('=== 调试信息 ===');
                      console.log('storeInfo.color:', state.storeInfo?.color);
                      console.log('storeInfo:', state.storeInfo);
                      console.log('areaid:', areaid);
                    }}
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#28a745',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    调试信息
                  </button>
                </div>
              )}

              <div>
                {/* <CategoryGrid categories={categories} storeInfo={state.storeInfo} /> */}
                <IconGrid storeInfo={state.storeInfo} />

                {/* <div className='p10' style={{ padding: '10px 15px' }}>
                  {
                    diningArr.length > 0 && (
                      <RecomProductCard stores={diningArr} />
                    )
                  }
                  {
                    restaurantArr.length > 0 && (
                      <>
                        <RestaurantCard title={intl.get('restaurant').d('餐厅')} list={restaurantArr} areaId={areaid} />
                      </>
                    )
                  }
                  {
                    spaArr.length > 0 && (
                      <div className='m-t-sm'>
                        <SpaCard title='Spa' list={spaArr} areaId={areaid} />
                      </div>
                    )
                  }
                  {
                    actStore && actStore.products && actStore.products.length > 0 && (
                      <div className='m-t-sm'>
                        <ProductCard
                          title='Activities'
                          list={actStore.products}
                          storeInfo={actStore}
                          viewAll={true}
                          areaId={areaid}
                          from='activity' />
                      </div>
                    )
                  }
                  {
                    tourStore && tourStore.products && tourStore.products.length > 0 && (
                      <div className='m-t-sm'>
                        <ProductCard
                          title='Tour'
                          list={tourStore.products}
                          storeInfo={tourStore}
                          from='tour'
                          viewAll={true}
                          areaId={areaid}
                        />
                      </div>
                    )
                  }
                  {
                    souvenirStore && souvenirStore.products && souvenirStore.products.length > 0 && (
                      <div className='m-t-sm'>
                        <ProductCard
                          title='Souvenir'
                          list={souvenirStore.products}
                          storeInfo={souvenirStore}
                          from='souvenir'
                          viewAll={true}
                          areaId={areaid}
                        />
                      </div>
                    )
                  }
                </div> */}

                {
                  state.storeInfo && state.storeInfo.partnerId && <RelateStoreCard storeInfo={state.storeInfo} areaid={areaid} />
                }

                {
                  state.storeInfo && state.storeInfo.partnerId ? (
                    <div className='m-t-sm1 js_promote_wrapper'>
                      <div className='com-title' style={{ padding: '0 15px 5px 15px' }}>{intl.get('promotion').d('Promotions')}</div>
                      <div style={{ padding: '0 5px' }}>
                        <PromotionList
                          areaId={areaid}
                          partnerId={state.storeInfo.partnerId}
                          method='rediect'
                          from='chain'
                          relateType='801,802'
                          popup={407}
                          storeInfo={state.storeInfo}
                        />
                      </div>
                    </div>
                  ) : null
                }

                <div>&nbsp;</div>
              </div>
            </>
          )
        }

      </div>
      <div>
        <NavigationBar callback={handleHomeRefresh} couponFlag={true} />
      </div>

      {/* <Popup
        visible={state.detailShow}
        onClose={() => setState(prev => ({ ...prev, detailShow: false }))}
        destroyOnClose
      >
        <ActivityDetail detail={state.activityDetail} callback={() => setState(prev => ({ ...prev, detailShow: false }))} />
      </Popup> */}
      {
        (extendData && extendData.isCheckAIAssistant && extendData1.isOpenAiChat && extendData1?.aiChatType === 2) && <MaxKBChatBot chatbotId={extendData1.key} />
      }


    </div>
  )
}

export default React.memo(Home);

